import React from "react";
import { useTranslation } from "react-i18next";

import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import { TextField } from "@material-ui/core";
import MenuItem from "@material-ui/core/MenuItem";
import { useSnackbar } from "notistack";

import DialogTitle from "@material-ui/core/DialogTitle";
import axios from "../../../config/axios";
import { UploadImage } from "components/UploadImage";

const useStyles = makeStyles(theme => ({
  form: {
    display: "flex",
    flexDirection: "column",
    margin: "auto",
    width: "fit-content"
  },
  formControl: {
    marginTop: theme.spacing(2),
    minWidth: 120
  },
  formControlLabel: {
    marginTop: theme.spacing(1)
  },
  col1: {
    fontWeight: "500",
    minWidth: "110px",
    padding: "10PX"
  },
  row1: {
    display: "flex",
    margin: "11px 0px 11px 0px"
  },
  details: {
    display: "flex",
    flexDirection: "column",
    padding: "30px",
    width: "90%"
  }
}));

export default function ItemAddDialog({ editItem, items, orderId, orderStatus, handleCloseItemDialog, handleCloseSuccessItemDialog }) {
  const [contentName, setContenName] = React.useState(editItem?.content_name || "");
  const [barcodeID, setBarcodeID] = React.useState("");
  const [product, setStatus] = React.useState(null);
  const [imageUrl, setImageUrl] = React.useState("");
  const [loading, setLoading] = React.useState(false);

  const { enqueueSnackbar } = useSnackbar();
  const { t } = useTranslation();

  const onContentNameChange = event => {
    setContenName(event.target.value);
  };

  const onBarcodeIDChange = event => {
    setBarcodeID(event.target.value);
  };

  const handleStatusChange = event => {
    setStatus(event.target.value);
  };

  const allowEmptyBarcode = orderStatus === "processing";

  const handleSaveItemDialog = async () => {
    let errorMessage;

    if (!contentName) errorMessage = t("messages.pleaseAddItemName");
    if (!allowEmptyBarcode) {
      if (!imageUrl) errorMessage = t("messages.pleaseUploadBarcodeImage");
      if (!barcodeID) errorMessage = t("messages.pleaseAddBarcodeId");
    }

    if (errorMessage) {
      enqueueSnackbar(errorMessage, { variant: "error" });
      return;
    }

    const body = {
      ...(!editItem && { product_id: product || (items?.items && items?.items[0]?._id) }),
      content_name: contentName,
      ...(barcodeID && { barcode_id: barcodeID }),
      ...(imageUrl && { barcode_image_url: imageUrl })
    };
    setLoading(true);
    await axios
      .patch(editItem ? `/admin/update-order-item/${editItem?._id}` : `/admin/add-order-item/${orderId}`, body)
      .then(res => {
        handleCloseSuccessItemDialog();
      })
      .catch(error => {
        enqueueSnackbar(error.response.data.message, { variant: "error" });
        return error;
      });
    setLoading(false);
  };

  const handleCloseItem = () => {
    handleCloseItemDialog();
  };

  const classes = useStyles();
  return (
    <React.Fragment>
      <Dialog fullWidth={true} maxWidth={"sm"} open={true} onClose={handleCloseItemDialog} aria-labelledby="max-width-dialog-title">
        <DialogTitle id="max-width-dialog-title">{editItem ? t("addItem.edit") : t("addItem.add")} {t("addItem.title")}</DialogTitle>
        <div className={classes.details}>
          {!editItem && (
            <div className={classes.row1}>
              <div className={classes.col1}>{t("addItem.product")}</div>
              <div style={{ width: "400px" }}>
                <TextField
                  id="standard-select-status"
                  select
                  label={t("addItem.product")}
                  value={product || items?.items?.[0]?._id}
                  fullWidth={true}
                  onChange={e => handleStatusChange(e)}
                  variant="outlined"
                >
                  {items.items.map(option => (
                    <MenuItem key={option._id} value={option._id}>
                      {option._id}
                    </MenuItem>
                  ))}
                </TextField>
              </div>
            </div>
          )}
          <div className={classes.row1}>
            <div className={classes.col1}>{t("addItem.contentName")}</div>
            <div style={{ width: "400px" }}>
              <TextField id="outlined-size-small" label={t("addItem.contentName")} rows={4} onChange={e => onContentNameChange(e)} value={contentName} variant="outlined" fullWidth={true} />
            </div>
          </div>
          <div className={classes.row1}>
            <div className={classes.col1}>{t("addItem.barcodeId")}</div>
            <div style={{ width: "400px" }}>
              <TextField id="outlined-size-small" label={t("addItem.barcodeId")} rows={4} onChange={e => onBarcodeIDChange(e)} value={barcodeID} variant="outlined" fullWidth={true} />
            </div>
          </div>
          <div className={classes.row1}>
            <div className={classes.col1}>{t("addItem.barcodeImage")}</div>
            <UploadImage setImageUrl={setImageUrl} setIsImageUploading={setLoading} setBarcodeID={setBarcodeID} />
          </div>
        </div>
        <DialogActions>
          <Button onClick={handleSaveItemDialog} color="primary" disabled={loading}>
            {loading ? t("addItem.loading") : t("addItem.add")}
          </Button>

          <Button onClick={handleCloseItem} color="primary">
            {t("addItem.close")}
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
